"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  download: function download(data, name) {
    var blob = new Blob([data], {
      type: 'application/vnd.ms-excel'
    });
    var fileName = name;
    if ('download' in document.createElement('a')) {
      // 非IE下载
      var elink = document.createElement('a');
      elink.download = fileName;
      elink.style.display = 'none';
      elink.href = URL.createObjectURL(blob);
      document.body.appendChild(elink);
      elink.click();
      URL.revokeObjectURL(elink.href); // 释放URL 对象
      document.body.removeChild(elink);
    } else {
      // IE10+下载
      navigator.msSaveBlob(blob, fileName);
    }
  },
  downloadPdf: function downloadPdf(data, name) {
    var blob = new Blob([data], {
      type: 'application/pdf'
    });
    var fileName = name;
    if ('download' in document.createElement('a')) {
      // 非IE下载
      var elink = document.createElement('a');
      elink.download = fileName;
      elink.style.display = 'none';
      elink.href = URL.createObjectURL(blob);
      document.body.appendChild(elink);
      elink.click();
      URL.revokeObjectURL(elink.href); // 释放URL 对象
      document.body.removeChild(elink);
    } else {
      // IE10+下载
      navigator.msSaveBlob(blob, fileName);
    }
  }
};